(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-showcase"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (!root || root.getAttribute('data-kart-ready')) return;
    root.setAttribute('data-kart-ready', '1');
    var rows = root.querySelectorAll('.kart__row');
    var imgs = root.querySelectorAll('.kart__stage img');
    var nameEl = root.querySelector('[data-kart-name]');
    var cta = root.querySelector('[data-kart-cta]');
    var ctaT = root.querySelector('[data-kart-cta-t]');
    Array.prototype.forEach.call(rows, function(b){
      b.addEventListener('click', function(){
        Array.prototype.forEach.call(rows, function(x){ x.classList.toggle('on', x === b); });
        Array.prototype.forEach.call(imgs, function(im){ im.classList.toggle('on', im.getAttribute('data-k') === b.getAttribute('data-k')); });
        var nm = b.getAttribute('data-name');
        if (nameEl) nameEl.textContent = nm;
        if (cta) { cta.href = b.getAttribute('data-link'); }
        if (ctaT) { ctaT.textContent = nm + ' ' + (cta.getAttribute('data-suffix') || ''); }
        if (b.getAttribute('data-tint')) root.style.setProperty('--tint', b.getAttribute('data-tint'));
      });
    });
  }
  document.querySelectorAll('[data-kart]').forEach(init);
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-kart]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
(function(){
  function money(cents){
    var el = document.getElementById('CartDrawer');
    var fmt = el ? el.getAttribute('data-money-format') : '';
    var num = (cents / 100).toFixed(2).replace('.', ',');
    var parts = num.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    num = parts.join(',');
    if (fmt.indexOf('amount_no_decimals') > -1) num = Math.round(cents / 100).toLocaleString('tr-TR');
    if (!fmt) return num + ' TL';
    var token = new RegExp('\\{\\{\\s*amount[a-z_]*\\s*\\}\\}', 'g');
    return fmt.replace(token, num) || (num + ' TL');
  }

  function init(root){
    if (!root || root.getAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '1');
    var $ = function(s){ return root.querySelector(s); };
    var $$ = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---- galeri ---- */
    var thumbs = $$('.gal__th button');
    var main = $('[data-gal-main]'), bg = $('.gal__bg'), cnt = $('[data-gal-count]');
    var dots = $$('.gal__dots i');
    var idx = Math.max(0, thumbs.map(function(t){ return t.classList.contains('on'); }).indexOf(true));
    var thRow = $('.gal__th'), galBox = $('.gal__main'), seq = 0;
    var vid = $('[data-gal-vid]'), vbtn = $('[data-gal-vbtn]'), vidAnim = null, vidTimer = null;
    if (vbtn) vbtn.addEventListener('click', function(){
      for (var k = 0; k < thumbs.length; k++) { if (thumbs[k].hasAttribute('data-video')) { show(k); return; } }
    });
    function decoded(img){
      return img.decode ? img.decode().catch(function(){}) : new Promise(function(r){ img.onload = img.onerror = r; });
    }
    /* Çapraz geçiş: yeni görsel ve bulanık zemini üstte ayrı katman olarak
       yüklenir, yüklendikten sonra belirir; ana görsel ancak o zaman değişir.
       seq: art arda tıklamada yalnızca son seçim uygulanır. */
    function show(i){
      if (!thumbs.length || !main) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx], my = ++seq;
      var src = t.getAttribute('data-full'), bsrc = t.getAttribute('data-bg');
      thumbs.forEach(function(x, k){ x.classList.toggle('on', k === idx); });
      dots.forEach(function(d, k){ d.classList.toggle('on', k === idx); });
      if (cnt) cnt.textContent = (idx + 1) + ' / ' + thumbs.length;
      if (thRow) thRow.scrollTo({ left: t.offsetLeft - (thRow.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });

      /* video küçük resmi: görsel değişmez, üstteki video katmanı belirir */
      var vurl = t.getAttribute('data-video');
      if (vid) {
        if (vbtn) vbtn.hidden = !!vurl;
        if (vurl) {
          if (!vid.getAttribute('src') && !vidAnim) vid.src = vurl;
          vid.classList.add('in');
          if (vidAnim) { vidAnim.classList.add('in'); return; }
          /* oynatma engellenirse ya da (iPhone'da olduğu gibi) hata vermeden hiç
             başlamazsa hareketli WebP'ye geçilir */
          var useAnim = function(){
            if (vidAnim || !vid.getAttribute('data-anim') || !vid.classList.contains('in')) return;
            vidAnim = new Image();
            vidAnim.alt = ''; vidAnim.className = 'gal__vid in';
            vidAnim.src = vid.getAttribute('data-anim');
            vid.parentNode.insertBefore(vidAnim, vid.nextSibling);
            vid.pause();
          };
          var tryPlay = function(){
            var pl = vid.play();
            if (pl && pl.catch) pl.catch(function(err){ if (!err || err.name !== 'AbortError') useAnim(); });
          };
          vid.muted = true;
          tryPlay();
          vid.addEventListener('loadeddata', tryPlay, { once: true });
          clearTimeout(vidTimer);
          vidTimer = setTimeout(function(){ if (vid.classList.contains('in') && vid.paused) useAnim(); }, 3000);
          return;
        }
        vid.classList.remove('in');
        if (vidAnim) vidAnim.classList.remove('in');
        vid.pause();
      }

      $$('.gal__swap').forEach(function(n){ n.remove(); });
      var layBg = document.createElement('img');
      layBg.className = 'gal__bg gal__swap'; layBg.alt = ''; layBg.setAttribute('aria-hidden', 'true'); layBg.src = bsrc;
      var lay = document.createElement('img');
      lay.className = 'gal__swap gal__swap-img'; lay.alt = ''; lay.src = src;
      decoded(lay).then(function(){
        if (my !== seq) return;
        galBox.appendChild(layBg); galBox.appendChild(lay);
        lay.getBoundingClientRect();
        layBg.classList.add('in'); lay.classList.add('in');
        main.classList.add('is-out');
        setTimeout(function(){
          if (my !== seq) return;
          main.removeAttribute('srcset');
          main.src = src;
          main.alt = t.getAttribute('data-alt') || '';
          if (bg) bg.src = bsrc;
          Promise.all([decoded(main), bg ? decoded(bg) : null]).then(function(){
            if (my !== seq) return;
            main.classList.add('no-tr');
            main.classList.remove('is-out');
            requestAnimationFrame(function(){
              layBg.remove(); lay.remove();
              requestAnimationFrame(function(){ main.classList.remove('no-tr'); });
            });
          });
        }, 320);
      });
    }
    thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ show(k); }); });
    var prev = $('[data-prev]'), next = $('[data-next]');
    if (prev) prev.addEventListener('click', function(){ show(idx - 1); });
    if (next) next.addEventListener('click', function(){ show(idx + 1); });
    var box = $('.gal__main'), x0 = null;
    if (box) {
      box.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
      box.addEventListener('touchend', function(e){
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }
    function showMedia(id){
      for (var k = 0; k < thumbs.length; k++) {
        if (thumbs[k].getAttribute('data-media-id') === String(id)) { show(k); return; }
      }
    }

    var packBox = $('[data-packs]');

    /* ---- adet + fiyat (paket seçimi yokken) ---- */
    var qtyIn = $('[data-qty]');
    var totals = Array.prototype.slice.call(document.querySelectorAll('[data-total]'));
    var current = null;
    function qty(){ return Math.max(1, parseInt(qtyIn ? qtyIn.value : 1, 10) || 1); }
    function refreshTotals(){
      if (packBox) return;
      var t = money((current ? current.price : 0) * qty());
      totals.forEach(function(el){ el.textContent = t; });
    }
    $$('[data-q-step]').forEach(function(b){
      b.addEventListener('click', function(){
        if (!qtyIn) return;
        qtyIn.value = Math.max(1, qty() + parseInt(b.getAttribute('data-q-step'), 10));
        refreshTotals();
      });
    });
    if (qtyIn && qtyIn.type !== 'hidden') qtyIn.addEventListener('input', refreshTotals);

    /* ---- varyant ---- */
    var variants = [];
    try { variants = JSON.parse($('[data-variant-json]').textContent) || []; } catch (e) {}
    var idField = $('[data-variant-id]');
    current = variants.filter(function(v){ return idField && String(v.id) === idField.value; })[0] || variants[0] || null;
    var priceEl = $('[data-price]'), compareEl = $('[data-compare]'), offEl = $('[data-off]');
    var addBtns = Array.prototype.slice.call(document.querySelectorAll('[data-add-btn],[data-cod-btn]'));
    var addLabel = $('[data-add-label]');
    var sbarTitle = document.querySelector('[data-sbar-title]');
    var groups = $$('[data-opt-index]');
    function selected(){
      return groups.map(function(g){
        var on = g.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function apply(){
      var want = selected(), match = null;
      for (var i = 0; i < variants.length && !match; i++) {
        var ok = true;
        for (var j = 0; j < want.length; j++) { if (want[j] !== null && variants[i].options[j] !== want[j]) { ok = false; break; } }
        if (ok) match = variants[i];
      }
      if (!match) return;
      current = match;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      var sale = match.compare_at_price && match.compare_at_price > match.price;
      if (compareEl) { compareEl.textContent = sale ? money(match.compare_at_price) : ''; compareEl.hidden = !sale; }
      if (offEl) {
        offEl.hidden = !sale;
        if (sale) offEl.textContent = '%' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + ' indirim';
      }
      addBtns.forEach(function(b){ b.disabled = !match.available; });
      if (addLabel) addLabel.textContent = match.available ? root.getAttribute('data-t-add') : root.getAttribute('data-t-soldout');
      if (sbarTitle) sbarTitle.textContent = match.title;
      if (match.featured_media) showMedia(match.featured_media.id);
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u.toString());
      }
      refreshTotals();
    }
    groups.forEach(function(g){
      g.addEventListener('click', function(e){
        var b = e.target.closest('[data-value]');
        if (!b) return;
        Array.prototype.forEach.call(g.querySelectorAll('[data-value]'), function(x){
          var on = x === b;
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
          x.classList.toggle('on', on);
        });
        var lbl = root.querySelector('[data-opt-label="' + g.getAttribute('data-opt-index') + '"]');
        if (lbl) lbl.textContent = b.getAttribute('data-value');
        apply();
      });
    });

    /* ---- paket: kart seçimi + her toka için renk ----
       Sepete her renk ayrı satır olarak eklenir (form data-items); paket
       fiyatı ödemede adede bağlı otomatik indirimle oluşur. */
    if (packBox) {
      var cards = $$('[data-pack]'), slots = $$('[data-slot]');
      var form = $('[data-product-form]');
      var n = parseInt(packBox.getAttribute('data-def'), 10) || 1;
      var unit = parseInt(packBox.getAttribute('data-unit'), 10) || 0;
      var byId = {};
      variants.forEach(function(v){ byId[String(v.id)] = v; });
      var slotBtn = function(s){ return s.querySelector('button.on') || s.querySelector('button'); };
      var cardFor = function(k){ return cards.filter(function(c){ return parseInt(c.getAttribute('data-pack'), 10) === k; })[0]; };

      var paint = function(){
        var card = cardFor(n);
        var total = card ? parseInt(card.getAttribute('data-pack-total'), 10) : unit * n;
        var cmp = unit * n;
        cards.forEach(function(c){
          var on = c === card;
          c.classList.toggle('on', on);
          c.querySelector('input').checked = on;
          Array.prototype.forEach.call(c.querySelectorAll('.pk2__stack i'), function(dot, i){
            if (slots[i]) dot.style.background = slotBtn(slots[i]).style.background;
          });
        });
        var counts = {}, order = [], names = [], ok = true;
        slots.forEach(function(s, i){
          s.hidden = i >= n;
          var b = slotBtn(s);
          var l = s.querySelector('[data-slot-l]'), v = s.querySelector('[data-slot-v]');
          if (l) l.textContent = n === 1 ? 'Renk' : (i + 1) + '. toka';
          if (v) v.textContent = b.getAttribute('data-name');
          if (i >= n) return;
          var id = b.getAttribute('data-vid');
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id]++;
          names.push(b.getAttribute('data-name'));
          if (byId[id] && !byId[id].available) ok = false;
        });
        var items = order.map(function(id){ return { id: parseInt(id, 10), quantity: counts[id] }; });
        if (form) form.setAttribute('data-items', JSON.stringify(items));
        if (idField && items[0]) idField.value = items[0].id;
        if (qtyIn) qtyIn.value = n;
        if (priceEl) priceEl.textContent = money(total);
        if (compareEl) { compareEl.hidden = !(cmp > total); compareEl.textContent = money(cmp); }
        if (offEl) { offEl.hidden = !(cmp > total); offEl.textContent = '%' + Math.floor((cmp - total) * 100 / cmp) + ' indirim'; }
        totals.forEach(function(el){ el.textContent = money(total); });
        if (sbarTitle) sbarTitle.textContent = n === 1 ? names[0] : n + ' Adet';
        addBtns.forEach(function(b){ b.disabled = !ok; });
        if (addLabel) addLabel.textContent = ok ? root.getAttribute('data-t-add') : root.getAttribute('data-t-soldout');
      };

      cards.forEach(function(c){
        c.querySelector('input').addEventListener('change', function(){
          n = parseInt(c.getAttribute('data-pack'), 10);
          paint();
        });
      });
      slots.forEach(function(s){
        s.addEventListener('click', function(e){
          var b = e.target.closest('button[data-vid]');
          if (!b) return;
          Array.prototype.forEach.call(s.querySelectorAll('button[data-vid]'), function(x){
            var on = x === b;
            x.classList.toggle('on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (b.getAttribute('data-mid')) showMedia(b.getAttribute('data-mid'));
          paint();
        });
      });

      /* Releasit kapıda ödeme formu: düğme <cart-drawer> içinde olduğu için form
         sepetin tamamıyla açılır. Tıklamayı önce biz yakalıyoruz: sepet boşaltılır,
         paketin bütün renkleri eklenir, sonra tıklama Releasit'e geçer. Form
         böylece paketi ve paket indirimini birebir gösterir. */
      if (form) {
        var rsiBusy = false, rsiPass = false;
        window.addEventListener('click', function(e){
          var b = e.target && e.target.closest ? e.target.closest('#rsi_buy_now_button') : null;
          if (!b || rsiPass || !form.contains(b)) return;
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          if (rsiBusy) return;
          rsiBusy = true;
          var rest = [];
          try { rest = JSON.parse(form.getAttribute('data-items') || '[]'); } catch (err) {}
          var post = function(url, body){
            return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) });
          };
          post('/cart/clear.js')
            .then(function(){ return rest.length ? post('/cart/add.js', { items: rest }) : null; })
            .catch(function(){})
            .then(function(){
              rsiBusy = false;
              rsiPass = true; b.click(); rsiPass = false;
              if (window.moleyaCartRefresh) setTimeout(window.moleyaCartRefresh, 1500);
            });
        }, true);
        var codSlot = $('[data-cod-slot]');
        if (codSlot) setTimeout(function(){
          var own = codSlot.querySelector('[data-cod-btn]');
          if (own && !codSlot.querySelector('#rsi_buy_now_button')) own.hidden = false;
        }, 4000);
      }

      /* ?adet=3 bağlantısı paketi önceden seçer (ana sayfadaki paket kartları) */
      var qa = parseInt(new URLSearchParams(window.location.search).get('adet'), 10);
      if (qa > 0 && cardFor(qa)) n = qa;
      paint();
    }
    refreshTotals();

    /* ---- "N kişinin sepetinde": ürün id + 3 saatlik dilim, F5'te zıplamaz ---- */
    $$('[data-in-carts]').forEach(function(el){
      var MIN = parseInt(el.getAttribute('data-min'), 10) || 5, MAX = parseInt(el.getAttribute('data-max'), 10) || 20;
      if (MAX < MIN) MAX = MIN;
      var pid = parseInt(el.getAttribute('data-product-id'), 10) || 1;
      var bucket = Math.floor(Date.now() / 1000 / (3 * 3600));
      function h(x){ return (x * 2654435761) % 4294967296; }
      var h1 = h((pid % 100003) + 1), h2 = h(Math.floor(h1 / 65536) + (h1 % 65536) + bucket + 1);
      var n = MIN + Math.floor(h2 / 65536 * (MAX - MIN + 1) / 65536);
      el.innerHTML = el.getAttribute('data-template').replace('__N__', '<strong>' + n + ' kişinin</strong>');
    });

    /* ---- "Bugün N adet satıldı" (demo): gün başında en az değerden başlar,
       saatlik satış ağırlığına göre gün içinde artar ve günün hedefine
       (en çok değere yakın) ulaşır. Herkeste aynı, F5'te azalmaz. ---- */
    $$('[data-sold-today]').forEach(function(el){
      var MIN = parseInt(el.getAttribute('data-min'), 10) || 50, MAX = parseInt(el.getAttribute('data-max'), 10) || 150;
      if (MAX < MIN) MAX = MIN;
      var tz = el.getAttribute('data-tz') || '+0300', tzMin = 180;
      if (/^[+-]\d{4}$/.test(tz)) tzMin = (tz[0] === '-' ? -1 : 1) * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10));
      var W = [1, .5, .3, .2, .2, .3, .6, 1, 1.5, 2, 2.4, 2.6, 2.8, 2.7, 2.6, 2.6, 2.7, 2.9, 3.2, 3.6, 4, 3.8, 3, 2];
      var tot = W.reduce(function(a, b){ return a + b; }, 0), out = el.querySelector('[data-sold-n]');
      function h(x){ return (x * 2654435761) % 4294967296; }
      function paint(){
        var now = new Date(Date.now() + tzMin * 60000), day = Math.floor(now.getTime() / 86400000);
        var target = MAX - Math.floor(h(day + 7) / 4294967296 * (Math.floor((MAX - MIN) / 4) + 1));
        var hr = now.getUTCHours(), acc = W[hr] * (now.getUTCMinutes() * 60 + now.getUTCSeconds()) / 3600;
        for (var i = 0; i < hr; i++) acc += W[i];
        out.textContent = (MIN + Math.floor((target - MIN) * acc / tot)) + ' adet';
      }
      paint(); el.hidden = false; setInterval(paint, 60000);
    });

    /* ---- son sipariş bildirimi (demo): köşede küçük kutu, ilk 12 sn sonra,
       sonra ~30 sn arayla 5 sn görünür. Sayfa başına en çok 6 kez; sepet açıkken
       ya da sekme arka plandayken çıkmaz; × ile oturum boyunca kapanır. ---- */
    $$('[data-recent-sales]').forEach(function(el){
      try { if (sessionStorage.getItem('rs-off')) return; } catch (e) {}
      var colors = [];
      try { colors = JSON.parse(el.querySelector('[data-rs-colors]').textContent); } catch (e) {}
      if (!colors.length) return;
      var NAMES = ['Ayşe K.', 'Zeynep T.', 'Elif D.', 'Merve A.', 'Büşra Y.', 'Selin Ö.', 'Esra Ç.', 'Gizem S.', 'Derya B.', 'Fatma G.', 'Ceren E.', 'İrem U.', 'Hatice M.', 'Sinem K.', 'Damla A.', 'Tuğçe Y.', 'Nur Ş.', 'Ebru T.', 'Pınar D.', 'Melike C.', 'Sena B.', 'Gamze İ.', 'Yasemin H.', 'Özge R.'];
      var CITIES = ['İstanbul', 'Ankara', 'İzmir', 'Bursa', 'Antalya', 'Konya', 'Adana', 'Kocaeli', 'Mersin', 'Kayseri', 'Eskişehir', 'Samsun', 'Gaziantep', 'Denizli', 'Sakarya', 'Tekirdağ', 'Muğla', 'Trabzon', 'Balıkesir', 'Aydın'];
      var PACKS = [1, 2, 2, 2, 3, 3, 4, 4, 1, 2];
      var first = (parseInt(el.getAttribute('data-first'), 10) || 12) * 1000;
      var gap = (parseInt(el.getAttribute('data-gap'), 10) || 30) * 1000;
      var img = el.querySelector('.rs__img'), who = el.querySelector('[data-rs-who]'),
          what = el.querySelector('[data-rs-what]'), when = el.querySelector('[data-rs-when]');
      var shown = 0, timer = null, hideT = null, lastName = -1;
      function pick(a){ return a[Math.floor(Math.random() * a.length)]; }
      function shuffled(a){ return a.slice().sort(function(){ return Math.random() - .5; }); }
      function fill(){
        var ni; do { ni = Math.floor(Math.random() * NAMES.length); } while (ni === lastName);
        lastName = ni;
        var n = Math.min(pick(PACKS), colors.length), cs = shuffled(colors).slice(0, n);
        img.src = cs[0].i;
        who.textContent = NAMES[ni] + ' · ' + pick(CITIES);
        what.textContent = n === 1 ? '1 adet aldı · ' + cs[0].n
          : (n === colors.length && n > 2 ? n + ' adet aldı · tüm renkler' : n > 2 ? n + ' adet aldı · ' + n + ' farklı renk' : n + ' adet aldı · ' + cs.map(function(c){ return c.n; }).join(', '));
        var m = 2 + Math.floor(Math.random() * 40);
        when.textContent = m + ' dk önce';
      }
      function next(d){ clearTimeout(timer); timer = setTimeout(show, d); }
      function show(){
        if (shown >= 6) return;
        if (document.hidden || document.body.classList.contains('cart-open')) { next(5000); return; }
        fill(); shown++;
        el.classList.add('is-on');
        hideT = setTimeout(function(){ el.classList.remove('is-on'); next(gap + Math.floor(Math.random() * 10000) - 5000); }, 5000);
      }
      el.querySelector('[data-rs-close]').addEventListener('click', function(){
        el.classList.remove('is-on'); clearTimeout(timer); clearTimeout(hideT); shown = 99;
        try { sessionStorage.setItem('rs-off', '1'); } catch (e) {}
      });
      next(first);
    });

    /* ---- paket indirimi sayacı (demo): gün, mağaza saatiyle eşit aralıklara
       bölünür (varsayılan 60 dk); sayaç içinde bulunulan aralığın sonuna sayar.
       Herkeste aynı görünür, aralık bitince baştan başlar. Saat 0 ise saat
       kutusu gizlenir. ---- */
    $$('[data-promo-timer]').forEach(function(el){
      var tz = el.getAttribute('data-tz') || '+0300', tzMin = 180;
      if (/^[+-]\d{4}$/.test(tz)) tzMin = (tz[0] === '-' ? -1 : 1) * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10));
      var parts = el.querySelectorAll('[data-pt]'), hourBits = el.querySelectorAll('[data-ph]');
      var cycle = (parseInt(el.getAttribute('data-cycle'), 10) || 60) * 60;
      function p(n){ return (n < 10 ? '0' : '') + n; }
      function tick(){
        var now = new Date(Date.now() + tzMin * 60000);
        var secs = now.getUTCHours() * 3600 + now.getUTCMinutes() * 60 + now.getUTCSeconds();
        var rem = cycle - (secs % cycle);
        Array.prototype.forEach.call(hourBits, function(x){ x.hidden = rem < 3600; });
        parts[0].textContent = p(Math.floor(rem / 3600));
        parts[1].textContent = p(Math.floor(rem % 3600 / 60));
        parts[2].textContent = p(rem % 60);
      }
      tick(); el.hidden = false; setInterval(tick, 1000);
    });

    /* ---- kargo geri sayımı: mağazanın saat dilimi ---- */
    $$('[data-countdown]').forEach(function(el){
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 16;
      var days = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(function(d){ return parseInt(d, 10); });
      var tz = el.getAttribute('data-tz') || '+0300', tzMin = 180;
      if (/^[+-]\d{4}$/.test(tz)) tzMin = (tz[0] === '-' ? -1 : 1) * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10));
      var NAMES = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
      var body = el.querySelector('span');
      function p(n){ return (n < 10 ? '0' : '') + n; }
      function tick(){
        var now = new Date(Date.now() + tzMin * 60000), day = now.getUTCDay();
        var secs = now.getUTCHours() * 3600 + now.getUTCMinutes() * 60 + now.getUTCSeconds(), rem = cutoff * 3600 - secs;
        var isShip = days.indexOf(day) !== -1;
        if (isShip && rem > 0) {
          body.innerHTML = el.getAttribute('data-t-prefix') + ' <b>' + p(Math.floor(rem / 3600)) + ':' + p(Math.floor(rem % 3600 / 60)) + ':' + p(rem % 60) + '</b> ' + el.getAttribute('data-t-suffix');
          el.classList.toggle('is-urgent', rem <= 3600);
        } else {
          var o = 1; while (o <= 7 && days.indexOf((day + o) % 7) === -1) o++;
          body.textContent = (isShip && o === 1) ? el.getAttribute('data-t-tomorrow') : el.getAttribute('data-t-next').replace('__DAY__', NAMES[(day + o) % 7]);
          el.classList.remove('is-urgent');
        }
      }
      tick(); setInterval(tick, 1000);
    });

    /* ---- mobil yapışkan çubuk: kaydırma başlayınca gelir, sayfanın en üstüne
       dönülene kadar kalır ---- */
    var bar = document.querySelector('[data-sbar]');
    if (bar) {
      var bekle = false;
      var guncelle = function(){ bar.classList.toggle('show', window.scrollY > 40); bekle = false; };
      window.addEventListener('scroll', function(){
        if (!bekle) { bekle = true; requestAnimationFrame(guncelle); }
      }, { passive: true });
      guncelle();
    }
  }
  document.querySelectorAll('[data-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-pdp]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* form gönderildikten sonra mesajı görünür bırak */
  document.addEventListener('DOMContentLoaded', function(){
    var panel = document.getElementById('ReviewFormPanel');
    if (panel && panel.querySelector('.prvf__ok, .prvf__err')) {
      panel.classList.add('is-open');
      var b = document.querySelector('[data-prv-form]');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
  });

  /* fotoğraf şeridi okları */
  document.addEventListener('click', function(e){
    var ok = e.target.closest('[data-prvg]');
    if (!ok) return;
    var row = ok.closest('.prvg').querySelector('[data-prvg-row]');
    row.scrollBy({ left: parseInt(ok.getAttribute('data-prvg'), 10) * row.clientWidth * .8, behavior: 'smooth' });
  });

  /* masonry: kısa kartlar uzun kartın altındaki boşluğa tırmansın; tek sütunda kapalı */
  var grid = document.querySelector('[data-prv-grid]');
  function olc(){
    if (!grid) return;
    var st = getComputedStyle(grid), sutun = st.gridTemplateColumns.split(' ').length, k = grid.children, i;
    if (sutun < 2) { grid.classList.remove('is-masonry'); for (i = 0; i < k.length; i++) k[i].style.gridRowEnd = ''; return; }
    var ara = parseFloat(st.columnGap) || 0;
    grid.classList.add('is-masonry');
    for (i = 0; i < k.length; i++) {
      k[i].style.gridRowEnd = '';
      if (k[i].classList.contains('is-more')) continue;
      k[i].style.gridRowEnd = 'span ' + Math.ceil((k[i].getBoundingClientRect().height + ara) / 6);
    }
  }
  if (grid) {
    var t; var ertele = function(){ clearTimeout(t); t = setTimeout(olc, 120); };
    olc();
    window.addEventListener('resize', ertele);
    window.addEventListener('load', olc);
    grid.querySelectorAll('img').forEach(function(g){ if (!g.complete) g.addEventListener('load', ertele); });
  }

  /* büyüteç */
  var kutu = document.getElementById('PrvLightbox'), liste = [], idx = 0, acan = null;
  function goster(n){
    idx = (n + liste.length) % liste.length;
    var img = kutu.querySelector('.prvlb__img');
    img.src = liste[idx];
    var tek = liste.length < 2;
    kutu.querySelector('[data-ph-prev]').hidden = tek;
    kutu.querySelector('[data-ph-next]').hidden = tek;
  }
  function kapat(){
    kutu.hidden = true;
    kutu.querySelector('.prvlb__img').src = '';
    document.body.style.overflow = '';
    if (acan) { acan.focus(); acan = null; }
  }

  document.addEventListener('click', function(e){
    var yaz = e.target.closest('[data-prv-form]');
    if (yaz) {
      var p = document.getElementById('ReviewFormPanel');
      if (!p) return;
      var acik = p.classList.toggle('is-open');
      yaz.setAttribute('aria-expanded', acik ? 'true' : 'false');
      if (acik) { var ilk = p.querySelector('input[name="contact[name]"]'); if (ilk) ilk.focus(); }
      return;
    }
    if (kutu) {
      var th = e.target.closest('[data-ph-full]');
      if (th) {
        var hepsi = th.closest('[data-prv-ph]').querySelectorAll('[data-ph-full]');
        liste = Array.prototype.map.call(hepsi, function(b){ return b.getAttribute('data-ph-full'); });
        acan = th; kutu.hidden = false; document.body.style.overflow = 'hidden';
        goster(Array.prototype.indexOf.call(hepsi, th));
        return;
      }
      if (e.target.closest('[data-ph-close]') || e.target === kutu) { kapat(); return; }
      if (e.target.closest('[data-ph-prev]')) { goster(idx - 1); return; }
      if (e.target.closest('[data-ph-next]')) { goster(idx + 1); return; }
    }
    /* "daha fazla göster": her tıkta bir parti açılır, butonda kalan sayı yazar */
    var btn = e.target.closest('[data-prv-more]');
    if (!btn) return;
    var gizli = btn.closest('.prv').querySelectorAll('.prvc.is-more');
    var parti = parseInt(btn.getAttribute('data-parti'), 10) || 6, acilan = 0;
    for (var i = 0; i < gizli.length && acilan < parti; i++) { gizli[i].classList.remove('is-more'); acilan++; }
    var kalan = gizli.length - acilan;
    if (kalan > 0) btn.querySelector('[data-prv-kalan]').textContent = kalan;
    else btn.parentNode.removeChild(btn);
    setTimeout(olc, 60);
  });
  document.addEventListener('keydown', function(e){
    if (!kutu || kutu.hidden) return;
    if (e.key === 'Escape') kapat();
    if (e.key === 'ArrowLeft') goster(idx - 1);
    if (e.key === 'ArrowRight') goster(idx + 1);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
